import { render, staticRenderFns } from "./Branch.vue?vue&type=template&id=1cfcc09c"
import script from "./Branch.vue?vue&type=script&lang=js"
export * from "./Branch.vue?vue&type=script&lang=js"
import style0 from "./Branch.vue?vue&type=style&index=0&id=1cfcc09c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports